import { Link } from 'react-router-dom';
import { getFolderLink, getWorkbooksLink } from '@/main/routing.utilities';
import { translateBreadcrumb } from '@/utilities/homescreen.utilities';
import type { WorkbookItemPreview } from '@/workbook/workbook.constants';

interface HeaderBreadcrumbsProps {
  breadcrumbs: WorkbookItemPreview[];
  isWorksheetDisplayed: boolean;
}

export const HeaderBreadcrumbs = ({ breadcrumbs, isWorksheetDisplayed }: HeaderBreadcrumbsProps) => {
  const getLink = (crumb: WorkbookItemPreview) =>
    crumb.id && !crumb.tabHash ? getFolderLink(crumb.id) : getWorkbooksLink(crumb.tabHash);

  return (
    <div className="flexNoGrow flexNoOverflow flexColumnContainer flexCenter">
      {!!breadcrumbs.length && isWorksheetDisplayed && (
        <span className="mt0 mb2 fs11">
          <ul className="unstyled-list text-not-bold flexColumnContainer headerBreadcrumbs folderBreadcrumbs mt0 mb0 flexNoGrow">
            {breadcrumbs.map((crumb) => (
              <li key={`crumbId_${crumb.id}`}>
                <Link to={getLink(crumb)}>{translateBreadcrumb(crumb)}</Link>
              </li>
            ))}
          </ul>
        </span>
      )}
    </div>
  );
};
